import { queryOptions } from '@tanstack/react-query';
import { GetSurveySummaryQueryParamsType } from './getSurveySummaryQuery.type';
import { getSurveySummaryFunction } from './getSurveySummaryQueryFunction';

export const getSurveySummaryQueryOptions = (
  params: GetSurveySummaryQueryParamsType,
) => {
  return queryOptions({
    queryKey: ['SurveySummary', params],
    queryFn: () => getSurveySummaryFunction(params),
  });
};
